export const indicatorFactorsAdministrationTranslation = {

  // menu
  codetable_administration: 8268,

  // codetable list
  add_new: 6943,
  add_child: 6943,
  add_sibling: 8383,
  delete: 7915,
  loading: 4501,
  search_hits: 7474,
  search_no_hits: 8309,
  no_access_to_codetable_administration: 8320,
  no_access_has_been_granted: 8156,
  no_codetable: 8381,
  no_code: 8382,
  no_category: 8404,
  hide_historical_factors: 8665,

  // codetable item header
  update_code: 8269,
  add_code: 8308,
  cancel: 3273,
  delete_code_item: 8350,
  delete_confirm: 8351,
  delete_with_descendants_confirm: 8355,
  code_item_successfully_deleted: 8352,
  new_code_item: 8363,
  duplicate_code_item: 8425,

  // codetable item
  label: 8268,
  cancel_changes: 7558,
  are_you_sure: 7460,
  undo_all: 5792,
  select_all: 8420,
  clear_all: 8421,
  go_back: 7966,
  validation_error: 8206,
  duplicate_code: 8426,

  // codetable item form
  must_be_filled_out: 5949,
  selected_value_disabled: 8453,
  manage_options: 8521,

  // codetable item overlay
  saving_code: 8272,
  deleting_code: 8354,
  updated_successfully: 8273,
  saved_successfully: 8356,
  duplicated_successfully: 8451,

  // code picker
  search_required_message: 8146,
  no_options_found: 7644,
  search: 7345,
  done: 7338,

  // indicator factors
  substance: 8600,
  substanceUom: 8601,
  substanceCategory: 8602,
  equipment: 8603,
  source: 8604,
  location: 8605,
  indicatorSubstance: 8606,
  indicatorSubstanceWarningText: 8613,
  indicatorSubstanceUoM: 8607,
  indicatorSubstanceCategory: 8608,
  indicatorType: 8619,
  validFrom: 8609,
  factor: 8610,
  unit: 8611,
  uoms: 8616,
  duplicate_rows_description: 8612,
  duplicate_rows_long_description: 8671,
  duplicate_rows_validation_title: 8684,
  duplicate_rows_validation_subtitle: 8689,
  duplicate_rows_validation_suggested_title: 8688,
  duplicate_rows_validation_suggested_message_first: 8687,
  duplicate_rows_validation_suggested_message_second: 8686,
  duplicate_rows_success: 8707,
  delete_rows_description: 8713,
  delete_rows_success: 8714,

  modified_codes: 8673,
  update_codes: 8674,
  message_unsaved_changes_warning: 8675,
  message_codes_updated: 8676,
  saving_factors: 8677,
  confirm_duplicate_rows: 8680,
  confirm_delete_rows: 8715,
  duplicate_info_text: 8741,
  duplicate_error_text_title: 8742,
  duplicate_error_text_subtitle: 8743,
  must_be_within_range: 7939
};

export type CodetableTranslation = {
  readonly [T in keyof typeof indicatorFactorsAdministrationTranslation]: string
};

export const standardUomSetId = 1;

export const configurationAlreadyExistsKey = '_KeyCombinationViolation';
